import { getAddress } from '@polaris/core/utils'
import { atom } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { chainsQuery } from '@/src/queries/keys/chains'
import { accountsAtom } from '@/src/stores/accounts/atoms'
import { cosmosDerivationPathsAtom } from '@/src/stores/hotkeys/atoms'

const supportedChainsAtom = atomWithQuery(() => {
  return {
    ...chainsQuery(),
    select: (data) => data?.chains,
  }
})

export const getConvertedChainAddressAtom = (
  address?: string,
  chainId?: string,
) =>
  atom((get) => {
    if (!address || !chainId) return address

    const chains = get(supportedChainsAtom)
    const chain = chains.data?.find((c) => c.chain_id === chainId)
    if (!chain) return address

    const derivationPaths = get(cosmosDerivationPathsAtom)

    return getAddress(address, chain.chain_type, chainId, derivationPaths)
  })

export const getChainAccountAtom = (address?: string, chainId?: string) =>
  atom((get) => {
    const accounts = get(accountsAtom)
    const convertedAddressAtom = getConvertedChainAddressAtom(
      address,
      // Accounts are stored as cosmos addresses in the case of cosmos accounts
      chainId?.startsWith('cosmos:') ? 'cosmos:cosmoshub-4' : chainId,
    )
    const convertedAddress = get(convertedAddressAtom)

    return accounts.find((a) => a.address === convertedAddress)
  })
